import * as action_types from './action_types';

export const show = () => ({
  type: action_types.IS_LOADING,
  data: {
    isLoading: true,
  },
});

export const hide = () => ({
  type: action_types.IS_LOADING,
  data: {
    isLoading: false,
  },
});
